<template>
  <div id="role-form">
    <BOverlay :show="formLoading" rounded="sm" variant="white" opacity="0.6" blur="2px">
      <h3 class="mt-2">{{ this.entity.id ? "Edit" : "Create" }} {{ $t("tenantForm.tenant") }} {{ entity.name }}</h3>
      <BButtonToolbar class="mb-2 pt-2 pb-2 border-light border-top border-bottom">
        <BButtonGroup>
          <BButton size="sm" variant="outline-primary" @click="onClose" class="custom-button"
            >{{ $t("tenantForm.close") }}
          </BButton>
          <BButton
            :disabled="!isDirty"
            class="ml-2"
            size="sm"
            variant="primary"
            @click="onSave"
            style="background-color: #0054a6"
          >
            <font-awesome-icon icon="save"></font-awesome-icon>
            {{ $t("tenantForm.save") }}
          </BButton>
        </BButtonGroup>
      </BButtonToolbar>

      <div class="row">
        <div class="col-8">
          <BForm ref="form">
            <BFormGroup id="input-group-name" description="Name should be unique." label="Name:" label-for="input-name">
              <BFormInput
                id="input-name"
                v-model="entity.name"
                placeholder="Enter Tenant Name"
                required
                type="text"
                @change="changeEvent(entity.name)"
              ></BFormInput>
            </BFormGroup>
            <BFormGroup id="input-group-tenant-id" label="Tenant Id:" label-for="input-tenant-id" v-if="isCreateMode">
              <BFormInput id="input-tenant-id" v-model="tenantId" required type="text"></BFormInput>
            </BFormGroup>
            <BFormGroup
              id="input-group-databaseName"
              label="Database Name:"
              label-for="input-databaseName"
              v-if="isCreateMode"
            >
              <BFormInput id="input-databasename" v-model="databaseName" required type="text"></BFormInput>
            </BFormGroup>
          </BForm>
        </div>
        <!-- /.col-8 -->
        <div class="col-4">
          <FeaturesPanel
            v-if="formReady"
            :disabled="isCreateMode || !canModifyPermissions"
            provider-name="T"
            :provider-key="this.id"
          />
        </div>
        <!-- /.col-4 -->
      </div>
      <!-- /.row -->
    </BOverlay>
  </div>
</template>

<script lang="ts">
import { Inject } from "inversify-props";
import { TenantApi } from "@/api";
import { TenantCreateDto, TenantDto, TenantUpdateDto } from "@/api/model";
import BaseFormMixin from "@/core/views/forms/BaseForm";
import { AxiosResponse } from "axios";
import AuditFormBlock from "@/core/views/pages/_components/AuditFormBlock.vue";
import FeaturesPanel from "@/core/views/pages/SaaS/_components/FeaturesPanel.vue";
import { PermissionGuard } from "@/core/plugins/permissions";
import { mixins, Options } from "vue-class-component";
import { BButton, BButtonGroup, BButtonToolbar, BForm, BOverlay, BFormGroup, BFormInput } from "bootstrap-vue-next";

@Options({
  components: {
    FeaturesPanel,
    AuditFormBlock,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BForm,
    BOverlay,
    BFormGroup,
    BFormInput
  }
})
export default class TenantForm extends mixins(BaseFormMixin<TenantDto, TenantCreateDto, TenantUpdateDto>) {
  meta = {
    gridRoute: "TenantsGrid",
    formEditRoute: "TenantFormEdit",
    entityTypeName: "Tenant"
  };

  @Inject("TenantApi")
  private readonly tenantApi!: TenantApi;

  private adminEmail = "admin@abp.io";
  private adminPassword = this.getAdminPassword();
  private tenantId = "";
  private connectionString = "";
  private databaseName = "";

  private getAdminPassword(): string {
    return "ABCxyz123!@#";
  }
  get canModifyPermissions(): boolean {
    return PermissionGuard("AbpTenantManagement.Tenants.ManageFeatures");
  }

  getRequest(id: string): Promise<AxiosResponse<TenantDto>> {
    return this.tenantApi.apiMultiTenancyTenantsIdGet(id);
  }

  createRequest(entity: TenantDto): Promise<AxiosResponse<TenantDto>> {
    return this.tenantApi.apiMultiTenancyTenantsPost(this.mapToCreateDto(entity));
  }

  updateRequest(id: string, entity: TenantDto): Promise<AxiosResponse<TenantDto>> {
    return this.tenantApi.apiMultiTenancyTenantsIdPut(id, this.mapToUpdateDto(entity));
  }
  changeEvent(value: string): void {
    if (this.databaseName == "") {
      this.databaseName = value;
    }
  }

  mapToCreateDto(entity: TenantDto): TenantCreateDto {
    return {
      name: entity.name,
      adminEmailAddress: this.adminEmail,
      adminPassword: this.adminPassword,
      extraProperties: {
        CDTenantId: this.tenantId,
        DefaultConnectionString: this.connectionString,
        DatabaseName: this.databaseName
      }
    } as TenantCreateDto;
  }

  mapToUpdateDto(entity: TenantDto): TenantUpdateDto {
    return {
      name: entity.name
    } as TenantUpdateDto;
  }
}
</script>
<style scoped>
.custom-button {
  color: #0054a6;
  background-color: white;
  border-color: #0054a6;
  transition: all 0.02s ease;
}
.custom-button:hover {
  color: white !important;
  background-color: #0054a6 !important;
  border-color: #0054a6;
}
#role-form {
  font-size: 14px;
  font-family: Arial, sans-serif;
}
</style>
